export default {
    pageTitle: 'Data exports',
    requestedBy: 'Requested by',
    date: 'Date',
    type: 'Type',
    equipmentReplicatedServicesReport: 'Equipment services',
    equipmentReplicatedServicesReportHover: 'Last completed service by service type of the equipment',
    completed: 'Completed',
    failed: 'Failed',
    scheduled: 'Scheduled',
    processing: 'Processing',
    equipmentReplicatedServicesWithAttachmentsReport: 'Equipment services with attachments',
    equipmentReplicatedServicesWithAttachmentsReportHover: 'Last completed service by service type of the equipment with attachments',
}